import { Row, Col, Segmented } from "antd";
import React from "react";
import Box from "../../../../components/Box/Box";
import HeadingSubHeading from "../../../../components/ViewHeading/HeadingSubHeading";
import TableComponent from "./TableComponent/TableComponent";
import MultiLineChart from "./Charts/MultiLineChart";

const UnplanedLeaveTaken = () => {
    const [value, setValue] = React.useState('Departments');

    const column = ["Department", "Employees", "Total Leave"];
    const Data = [
        {
            Department: "Human Resource",
            'Total Leave': 5,
            Employees: 10,
        },
        {
            Department: "Finance",
            'Total Leave': 7,
            Employees: 15,
        },
        {
            Department: "Marketing",
            'Total Leave': 8,
            Employees: 20,
        },
        {
            Department: "IT",
            'Total Leave': 5,
            Employees: 10,
        },
        {
            Department: "Operations",
            'Total Leave': 6,
            Employees: 12,
        }
    ]

    const locationColumn = ["Location", "Employees", "Total Leave"];
    const locationData = [
        {
            Location: "Delhi",
            'Total Leave': 5,
            Employees: 10,
        },
        {
            Location: "Mumbai",
            'Total Leave': 7,
            Employees: 15,
        },
        {
            Location: "Bangalore",
            'Total Leave': 8,
            Employees: 20,
        },
        {
            Location: "Pune",
            'Total Leave': 5,
            Employees: 10,
        },
        {
            Location: "Chennai",
            'Total Leave': 6,
            Employees: 12,
        },
    ]


    return <Row gutter={[16, 16]}>
        <Col span={24}>
            <HeadingSubHeading title="Unplanned Leave Taken by Department" titleProps={{ level: 5 }} />
        </Col>
        <Col span={24}>
            <Box title={'Unplanned leave Taken by Department'} actions={<Segmented options={['Departments', 'Locations']} value={value} onChange={setValue} />}>
                <div style={{ maxWidth: 500 }}>
                    <TableComponent key={value} columns={value == 'Departments' ? column : locationColumn} data={value == 'Departments' ? Data : locationData} />
                </div>
                {value == 'Departments' ? <MultiLineChart Data={Data} xaxisName={'Department'} lineDataKey1={'Employees'} lineDataKey2={'Total Leave'} /> :
                    <MultiLineChart Data={locationData} xaxisName={'Location'} lineDataKey1={'Employees'} lineDataKey2={'Total Leave'} />}
            </Box>
        </Col>
    </Row>
}

export default UnplanedLeaveTaken;